import Image from "next/image";
import styles from "./page.module.css";
// import heroImg from '../../assets/img/hero/sld-1.jpg'
import heroImage from "../public/../assets/img/hero/sld-1.jpg";
import Navbar from "@/components/Shared/Navbar/Navbar";
import Link from "next/link";
import Footer from "@/components/Shared/Footer/Footer";
import { Swiper, SwiperSlide } from "swiper/react";
import PartnersFeatured from "@/components/Shared/Partners/PartnersFeatured";
import ProductsLatest from "@/components/Products/ProductsLatest";
import CorporateLogo from "@/components/CorporateLogo/CorporateLogo";
import TestimonialsSlide from "@/components/Testimonials/TestimonialsSlide";
import PartnerLogo from "@/components/PartnerLogo/PartnerLogo";
import Banner from "@/components/Banner/Banner";
import { Metadata } from "next";
import PartnerLogoContainer from "@/components/PartnerLogo/PartnerLogoContainer";
import AboutIndex from "@/components/About/AboutIndex";
import CorporateLogoContainer from "@/components/CorporateLogo/CorporateLogoContainer";
import BlogIndex from "@/components/Blog/BlogIndex";
import BannerFeatureCards from "@/components/Banner/BannerFeatureCards";
import WhyChooseUs from "@/components/WhyChooseUs/WhyChooseUs";
import Testimonial from "@/components/Testimonials/Testimonial";
import StatsCounter from "@/components/Stats/StatsCounter";
import WorkingProcessContainer from "@/components/WorkingProcess/WorkingProcessContainer";
import BrandFeaturedContainer from "@/components/Brand/BrandFeaturedContainer";
import ProductsLatestContainer from "@/components/Products/ProductsLatestContainer";
import urls from "@/utils/urls/urls";
import AnimationWrapper from "@/components/AnimationWrapper/AnimationWrapper";
import ProductsSection from "@/components/Products/ProductsSection";
export const metadata: Metadata = {
  title: "TEX EXCELLENCE LIMITED",
  description:
    "TEX EXCELLENCE LIMITED, a leading textile solutions provider, is committed to delivering high-quality textile products and innovative solutions that meet the diverse needs of our global clientele. With decades of experience in the textile industry, we specialize in a wide range of products including fabrics, garments, and accessories. Our state-of-the-art manufacturing facilities and dedicated team of experts ensure that every product we deliver upholds the highest standards of quality and craftsmanship. At TEX EXCELLENCE LIMITED, we are passionate about sustainability and are continually seeking ways to reduce our environmental footprint through eco-friendly practices and sustainable sourcing. Our customer-centric approach drives us to build long-lasting relationships with our clients, offering personalized services and tailored solutions to meet their specific requirements. Whether you are a small business or a large corporation, TEX EXCELLENCE LIMITED is your trusted partner in the textile industry, delivering excellence and innovation every step of the way.",
};

export default async function Home() {
  // const settingRes = await fetch(urls?.setting)
  // if (!settingRes.ok) {
  //   // console.log("aboutRes has an Error", settingRes)
  // }

  // const settingData = await settingRes.json()
  //   // console.log("settingData", settingData)

  return (
    <div className="bg-white">
      <>
        <Navbar />

        {/* sidebar-popup end */}
        <main className="main">
          {/* hero area */}

          <div className="hero-section">
            <Banner />
          </div>

          {/* hero area end */}
          {/* feature area */}
          <BannerFeatureCards />
          {/* <div className="feature-area fa-negative">
            <div className="container">
              <div className="feature-wrap">
                <div className="row g-4">
                  <div className="col-md-6 col-lg-4">
                    <div className="feature-item">
                      <span className="count">01</span>
                      <div className="feature-icon">
                        <img src="../assets/img/icon/staff.svg" alt="" />
                      </div>
                      <div className="feature-content">
                        <h4>Experts Staff</h4>
                        <p>
                          It is a long established fact that a reader will be distract
                          by the page readable content when are the looking at its
                          using layout.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="feature-item">
                      <span className="count">02</span>
                      <div className="feature-icon">
                        <img src="../assets/img/icon/money.svg" alt="" />
                      </div>
                      <div className="feature-content">
                        <h4>Affordable Pricing</h4>
                        <p>
                          It is a long established fact that a reader will be distract
                          by the page readable content when are the looking at its
                          using layout.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-4">
                    <div className="feature-item">
                      <span className="count">03</span>
                      <div className="feature-icon">
                        <img src="../assets/img/icon/support.svg" alt="" />
                      </div>
                      <div className="feature-content">
                        <h4>24/7 Support</h4>
                        <p>
                          It is a long established fact that a reader will be distract
                          by the page readable content when are the looking at its
                          using layout.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          {/* feature area end */}
          {/* about area */}
          <AboutIndex />
          {/* about area end */}
          {/* service area */}
          <AnimationWrapper animation="fade-up">
            <BrandFeaturedContainer />
          </AnimationWrapper>
          {/* service area end */}
          {/* process area */}
          <AnimationWrapper animation="fade-up">
            <WorkingProcessContainer />
          </AnimationWrapper>
          {/* process area end */}
          {/* skill-area */}
          {/* <div className="skill-area pb-120">
      <div className="container">
          <div className="skill-wrap">
              <div className="row g-4 align-items-center">
                  <div className="col-lg-6">
                      <div className="skill-img wow fadeInLeft" data-wow-delay=".25s">
                          <img src="../assets/img/skill/02.jpg" alt="thumb">
                      </div>
                  </div>
                  <div className="col-lg-6">
                      <div className="skill-content wow fadeInUp" data-wow-delay=".25s">
                          <span className="site-title-tagline"><i className="far fa-solar-panel"></i> Our
                              Skills</span>
                          <h2 className="site-title">We offers Mechine <span>that's easy</span> and efficient.</h2>
                          <p className="skill-text">
                              There are many variations of passages of Lorem Ipsum available, but the majority
                              have suffered alteration in some form, by injected humour, or randomised words which
                              don't look even slightly believable.
                          </p>
                          <div className="skill-progress">
                              <div className="progress-item">
                                  <h5>Mechine <span className="percent">85%</span></h5>
                                  <div className="progress" data-value="85">
                                      <div className="progress-bar" role="progressbar"></div>
                                  </div>
                              </div>
                              <div className="progress-item">
                                  <h5>Mechine Installation <span className="percent">65%</span></h5>
                                  <div className="progress" data-value="65">
                                      <div className="progress-bar" role="progressbar"></div>
                                  </div>
                              </div>
                              <div className="progress-item">
                                  <h5>Mechine service <span className="percent">75%</span></h5>
                                  <div className="progress" data-value="75">
                                      <div className="progress-bar" role="progressbar"></div>
                                  </div>
                              </div>
                          </div>
                          <Link href="#" className="theme-btn mt-5">Learn More<i className="fas fa-arrow-right"></i></Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div> */}
          {/* skill area end */}
          {/* portfolio area */}
          <ProductsSection />
          {/* portfolio area end */}
          {/* pricing area */}
          {/* pricing area end */}
          {/* counter area */}
          <StatsCounter />

          {/* counter area end */}
          {/* team-area */}
          {/* <TeamMembers /> */}
          <PartnerLogoContainer />
          {/* <PartnerLogo /> */}
          {/* cta area */}

          {/* cta area end */}
          {/* partner area */}

          {/* team-area end */}
          {/* quote area */}
          {/* <RequestQuote /> */}
          {/* TODO: Need To Dynamic Form */}
          {/* quote area end */}
          {/* location area */}

          {/* location area end */}
          {/* cta area */}
          <div
            className="cta-area pt-70 pb-120"
            style={{ backgroundImage: "url(../assets/img/cta/01.jpg)" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 mx-auto">
                  <div
                    className="cta-content wow fadeInUp"
                    data-wow-delay=".25s"
                  >
                    <h1>
                      We provide sustainable &amp; reliable automatic systems
                    </h1>
                    <p>
                      It is a long established fact that a reader will be
                      distracted by the readable content of a page when the
                      majority have suffered alteration looking at its layout.
                    </p>
                    <Link href="contact" className="theme-btn">
                      Contact Now
                      <i className="fas fa-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* cta area end */}
          {/* partner area */}
          <div className="partner-area pa-negative">
            <div className="container">
              <div className="partner-wrapper">
                <CorporateLogoContainer />
              </div>
            </div>
          </div>
          {/* partner area end */}
          {/* choose area */}
          <WhyChooseUs />

          {/* choose area end */}
          {/* testimonial-area */}
          <Testimonial />
          {/* <div className="testimonial-area tm-bg pt-80 pb-60">
            <div className="container">
              <div className="row">
                <div className="col-lg-4">
                  <div className="site-heading wow fadeInDown" data-wow-delay=".25s">
                    <span className="site-title-tagline">
                      <i className="fas fa-solar-panel" /> Testimonials
                    </span>
                    <h2 className="site-title text-white">
                      What Our Client <span>Say's</span> about us
                    </h2>
                    <p className="text-white">
                      It is a long established fact that a reader will be distracted
                      by the readable content of a page when looking at its layout.
                      All the generators on the Internet tend to repeat predefined
                      chunks.
                    </p>
                    <Link href="contact" className="theme-btn mt-30">
                      Know More <i className="fas fa-arrow-right" />
                    </Link>
                  </div>
                </div>
                <div className="col-lg-8">
                  <TestimonialsSlide />
                </div>
              </div>
            </div>
          </div> */}
          {/* testimonial-area end */}
          {/* blog-area */}
          <BlogIndex />

          {/* blog-area end */}
        </main>
        {/* footer area */}
        <Footer />
        {/* footer area end */}
        {/* scroll-top */}
        <Link href="#" id="scroll-top">
          <i className="far fa-arrow-up" />
        </Link>
        {/* scroll-top end */}
        {/* js */}
      </>
    </div>
  );
}
